module.exports = __webpack_public_path__ + "img/dc.5aa2d340.svg";